import { Image } from 'react-bootstrap'
import Table from '@mui/material/Table'
import { TableBody, TableCell, TableRow } from '@mui/material'
import ImgNotFound from '../../../../../images/no-img.svg'

const TableAssets = ({ data }) => {
  return (
    <>
      <div>
        <p
          className="text-primary small mt-5"
          style={{
            opacity: 1
          }}
        >
          Assets
        </p>
      </div>

      <Table hover striped responsive>
        <thead
          className="text-dark "
          style={{
            position: 'sticky',
            top: '0px',
            backgroundColor: '#E0E0E0'
          }}
        >
          <TableRow className="row fw-light font-title-table">
            <TableCell
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                opacity: 1
              }}
              className="fw-bold text-center col-1 fw-normal"
            >
              #
            </TableCell>
            <TableCell
              className="fw-bold text-center col-1 fw-normal"
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                opacity: 1
              }}
            >
              Category
            </TableCell>
            <TableCell
              className="fw-bold text-center col-1 fw-normal"
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                opacity: 1
              }}
            >
              Assets Tag
            </TableCell>
            <TableCell
              className="fw-bold text-center col-1 fw-normal"
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                opacity: 1
              }}
            >
              Name
            </TableCell>
            <TableCell
              className="fw-bold text-center col-1 fw-normal"
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                opacity: 1
              }}
            >
              Model
            </TableCell>
            <TableCell
              className="fw-bold text-center col-1 fw-normal"
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                opacity: 1
              }}
            >
              Serial
            </TableCell>
            <TableCell
              className="fw-bold text-center col-1 fw-normal"
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                opacity: 1
              }}
            >
              Image
            </TableCell>
            <TableCell
              className="fw-bold text-center col-1 fw-normal"
              style={{
                fontSize: '13px',
                whiteSpace: 'nowrap',
                opacity: 1
              }}
            >
              Status
            </TableCell>
          </TableRow>
        </thead>
        <TableBody style={{ background: '#FFFFFF' }}>
          {data?.length > 0 ? (
            data.map((d, i) => (
              <TableRow className="font-small-2" key={i}>
                <TableCell
                  className="text-center"
                  style={{
                    fontSize: '14px',
                    color: '#7b818e',
                    opacity: 1
                  }}
                >
                  {i + 1}
                </TableCell>

                <TableCell
                  className="font-small-2"
                  style={{
                    fontSize: '14px',
                    color: '#7b818e',
                    opacity: 1
                  }}
                >
                  {d.category}
                </TableCell>

                <TableCell
                  className="font-small-2"
                  style={{
                    fontSize: '14px',
                    color: '#7b818e',
                    opacity: 1
                  }}
                >
                  {d.asset_tag}
                </TableCell>

                <TableCell
                  className="font-small-2"
                  style={{
                    fontSize: '14px',
                    color: '#7b818e',
                    opacity: 1
                  }}
                >
                  {d.name}
                </TableCell>

                <TableCell
                  className="font-small-2"
                  style={{
                    fontSize: '14px',
                    color: '#7b818e',
                    opacity: 1
                  }}
                >
                  {d.model}
                </TableCell>

                <TableCell
                  className="font-small-2"
                  style={{
                    fontSize: '14px',
                    color: '#7b818e',
                    opacity: 1
                  }}
                >
                  {d.serial}
                </TableCell>

                <TableCell>
                  {d.image === null ? (
                    <Image
                      className=" mx-auto d-block"
                      src={ImgNotFound}
                      disable={ImgNotFound}
                      onError={(event) => {
                        event.target.src = ImgNotFound
                        event.onerror = null
                      }}
                      style={{
                        opacity: '30%',
                        width: '40px',
                        height: '40px',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    />
                  ) : (
                    <Image
                      id="imgEx"
                      src={d.image}
                      // onClick={handleClick}
                      disable={ImgNotFound}
                      onError={(event) => {
                        event.target.src = ImgNotFound
                        event.onerror = null
                      }}
                      style={{
                        display: 'flex',
                        // opacity: "100%",
                        width: '80px',
                        height: '80px',
                        objectFit: 'cover',
                        margin: 'auto',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    ></Image>
                  )}
                </TableCell>

                <TableCell>
                  <p
                    className="font-small-2"
                    style={{
                      fontFamily: "Sarabun', sans-serif",
                      fontSize: '14px',
                      color: '#7b818e',
                      opacity: 1
                    }}
                  >
                    {d.status}
                  </p>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow className="mb-0">
              <TableCell
                className="text-center fw-light"
                colSpan={8}
                style={{
                  fontFamily: "Sarabun', sans-serif",
                  fontSize: '14px',
                  color: '#7b818e',
                  opacity: 1
                }}
              >
                -No Data-
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </>
  )
}

export default TableAssets
